import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useCollectionOverrideHistory } from './useCollectionOverrideHistory';
import { useSelectedCollection } from '../../Collection/hooks/useSelectedCollectionSelectors';
import { GetOverrideHistoryArgs } from '../types';

export const useSelectedCollectionOverrideHistory = () => {
    const { selectedCollection } = useSelectedCollection();

    const queryArgs: SkipOrArgs<GetOverrideHistoryArgs> = useMemo(() => {
        if (!selectedCollection?.proscopeId) return skipToken;

        return {
            proscopeId: selectedCollection.proscopeId,
        };
    }, [selectedCollection]);

    return useCollectionOverrideHistory(queryArgs);
};
